import type { PropsWithChildren } from "react";

import { showStateDevTools } from "@/config/environmentUtils";

import { StateDevTools } from "./state-dev-tools.component";

export const StateDevToolsWrapper = ({ children }: PropsWithChildren) => {
  if (!showStateDevTools()) return children;

  return <StateDevTools>{children}</StateDevTools>;
};
